@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../respond-to.scss';
@import '../../global-styles/index.scss';

@mixin icon($icon_path) {
  width: $typography-icon-large-size;
  height: $typography-icon-large-size;
  background-image: url($url + $icon_path);
}

.ci-Footer {
  padding-top: 3rem;

  &-body {
    padding-bottom: 2rem;
    background-color: $color-shade-white;
  }

  &-bodyLayout {
    margin: 1rem;
  }

  &-bodyList {
    &--hours {
      padding-bottom: $spacing-32;
    }
    &-itemHeader {
      color: $color-gray-slate-dark;
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
      letter-spacing: 0.015em;
      padding-bottom: $spacing-16;
    }

    &-itemHour {
      color: $color-gray-slate-default;
      font-size: $typography-body-long2-size;
      line-height: $typography-body-long2-line-height;
      letter-spacing: -0.01em;
      padding-bottom: 4px;
    }

    &--contact {
      display: flex;
      flex-direction: column;
      gap: $spacing-16;
    }
    &-chat,
    &-email {
      display: flex;
      gap: 12px;
      justify-content: flex-start;
      text-decoration: none;

      &-text {
        color: $color-gray-slate-default;
        font-size: $typography-body-long2-size;
        line-height: $typography-body-long2-line-height;
        letter-spacing: -0.01em;

        &:hover {
          color: $color-blue-default;
        }
      }
    }
    &-chat {
      a.img {
        cursor: pointer;
        height: 22px;
      }
    }
  }
}

@include breakpoint('md') {
  .ci-Footer {
    &-bodyList {
      margin: 0;

      &-itemHeader br {
        display: none;
      }
      &-list {
        display: flex;
      }
      &-itemHour:not(:last-of-type) {
        padding: 0 $spacing-16 0 0;
        border-right: 1px solid $color-gray-accent;
        margin-right: $spacing-16;
      }
      &--contact {
        flex-direction: row;
        gap: $spacing-32;
      }
    }
  }
}

@include breakpoint('lg') {
  .ci-Footer {
    &-bodyLayout {
      display: flex;
      justify-content: space-between;
      margin: 0;
    }

    &-bodyList {
      margin: 0;

      &-itemHeader br {
        display: none;
      }
      &-list {
        display: flex;
      }
      &-itemHour:not(:last-of-type) {
        padding: 0 $spacing-16 0 0;
        border-right: 1px solid $color-gray-accent;
        margin-right: $spacing-16;
      }
    }
  }
}

@include breakpoint('xl') {
  .ci-Footer {
    &-bodyLayout {
      display: flex;
      justify-content: space-between;
      margin: 0;
    }

    &-bodyList {
      margin: 0;

      &-itemHeader br {
        display: none;
      }
      &-list {
        display: flex;
      }
      &-itemHour:not(:last-of-type) {
        padding: 0 16px 0 0;
        border-right: 1px solid $color-gray-accent;
        margin-right: 16px;
      }
    }
  }
}

.ci-FooterCoda {
  background-color: $color-gray-light;
  &-wrapper {
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    gap: 16px;
  }

  &-nav,
  &-links,
  &-copyright,
  &-trademark {
    color: $color-gray-limestone;
    font-size: $typography-caption-caption-regular-size;
    line-height: $typography-caption-caption-regular-line-height;
    letter-spacing: $typography-caption-caption-regular-letter-spacing;
    font-weight: 600;
    text-align: center;
  }

  &-horizontal-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    list-style: none;
    padding-left: 0;
    margin: 0;

    span {
      color: $color-gray-limestone;

      &:not(:first-of-type):before {
        content: '•';
        padding: 0 4px;
        display: inline-block;
        text-align: center;
      }

      a, span#ot-sdk-btn {
        text-decoration: none;
        color: $color-gray-limestone;
        &:hover {
          color: $color-blue-default;
        }
      }
      span#ot-sdk-btn {
        font-size: 12px;
        letter-spacing: 0.015em;
        font-weight: 600;
        text-align: center;
        vertical-align: middle;
      }
    }
  }

  // Viewports: 320px -- iPhone 12 mini & SE, Galaxy S22, S10, & S20
  @media ((min-width: 304px) and (max-width: 330px)) {
    &-nav {
      .ci-FooterCoda-horizontal-list {
        li:nth-of-type(3):before,
        li:nth-of-type(5):before {
          content: '';
        }
      }
    }

    &-links {
      .ci-FooterCoda-horizontal-list {
        li:nth-of-type(3):before {
          content: '';
        }
      }
    }
  }

  // Viewports: 375px, 384px, -- iPhone 13 mini, 11 Pro, XS, X, 7, & 6, Galaxy S21 Ultra
  @media ((min-width: 374px) and (max-width: 384px)) {
    &-nav {
      .ci-FooterCoda-horizontal-list {
        li:nth-of-type(4):before {
          content: '';
          width: 4px;
        }
      }
    }

    &-links {
      .ci-FooterCoda-horizontal-list {
        li:nth-of-type(3):before {
          content: '';
        }
      }
    }
  }

  // Viewports:  390px, 393px -- iPhone 14, 14 Pro, 13, 13 Pro, 12, 12 Pro
  @media ((min-width: 385px) and (max-width: 396px)) {
    &-nav {
      .ci-FooterCoda-horizontal-list {
        li:nth-of-type(4):before {
          content: '';
          width: 4px;
        }
      }
    }
  }

  // Viewports: 412px, 414px -- iPhone 11, 11 Pro Max, XS Max, & XR, Pixel 6, & Galaxy Note 20
  @media ((min-width: 397px) and (max-width: 416px)) {
    &-nav {
      .ci-FooterCoda-horizontal-list {
        li:nth-of-type(4):before {
          content: '';
        }
      }
    }
    &-links {
      .ci-FooterCoda-horizontal-list {
        li:nth-of-type(3):before {
          content: '';
        }
      }
    }
  }

  // Viewports: 428px, 430px -- iPhone 14 Plus, 14 Pro Max, 13 Pro Max, 12 Pro Max
  @media ((min-width: 422px) and (max-width: 512px)) {
    &-nav {
      .ci-FooterCoda-horizontal-list {
        li:nth-of-type(4):before {
          content: '';
        }
      }
    }
  }
}

/* One Trust CSS - override StyleBitz */
.ot-sdk-show-settings, #ot-sdk-btn.ot-sdk-show-settings, #ot-sdk-btn.optanon-show-settings,
.ci-Footer .ot-sdk-show-settings,
.ci-Footer #ot-sdk-btn.ot-sdk-show-settings,
.ci-Footer #ot-sdk-btn.optanon-show-settings {
  color: $color-gray-limestone !important;
  border: 0 !important;
  padding: 0 !important;
  display: inline !important;
  font-size: 12px !important;
  line-height: 1.2 !important;
  cursor: pointer !important;
  &:hover {
    background: transparent !important;
    color: $color-blue-default !important;
  }
}